<template>
    <v-dialog
        v-model="ativarDialog"
        width="50em"
        lazy
        :fullscreen="$vuetify.breakpoint.xs"
        hide-overlay
        scrollable
        @click:outside="
            ativarDialog = false
        "
        @keydown.esc="
            ativarDialog = false
        "
    >
        <v-tooltip bottom slot="activator">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    color='info'
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon>airport_shuttle</v-icon>
                </v-btn>
            </template>
            <h3>Tipo de veículos</h3>
        </v-tooltip>
        <v-card>
            <v-card-title class="justify-center">
                <v-btn
                    icon
                    color="info"
                    @click="step = 1, tipoSelecionado = undefined"
                    v-if="step > 1"
                    style="
                        position: absolute;
                        left: 1.5em;
                    "
                >
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <h1>{{ titulo }}</h1>
                <v-btn
                    icon
                    color="info"
                    @click="step = 2"
                    v-if="step === 1"
                    style="
                        position: absolute;
                        right: 1.5em;
                    "
                >
                    <v-icon>add</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-alert v-model="alerta.ativo" :type="alerta.tipo" style="width: 100%;">
                {{ alerta.texto }}
            </v-alert>
            <v-card-text>
                <v-stepper v-model="step" style="box-shadow: none;" class="ma-0 pa-0">
                    <v-stepper-items>
                        <v-stepper-content step="1" class="justify-center ma-0 pa-0">
                            <v-list class="ma-0 pa-0">
                                <v-list-tile v-for="(tipo_veiculo, index) in tiposVeiculo" :key="index">
                                    <v-list-tile-avatar>
                                        <v-icon color="info">airport_shuttle</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ tipo_veiculo.denominacao }}</v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action class="justify-space-around d-inline">
                                        <v-tooltip bottom>
                                            <v-btn
                                                slot="activator"
                                                icon
                                                class="mr-2"
                                                @click="tipoSelecionado = tipo_veiculo, step = 3"
                                            >
                                                <v-icon color="error">delete</v-icon>
                                            </v-btn>
                                            <span>Apagar Tipo de veículo</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <v-btn
                                                slot="activator"
                                                icon
                                                @click="tipoSelecionado = tipo_veiculo, step = 2"
                                            >
                                                <v-icon color="info">edit</v-icon>
                                            </v-btn>
                                            <span>Editar Tipo de veículo</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>
                        </v-stepper-content>
                        <v-stepper-content step="2" class="justify-center ma-0 pa-0">
                            <v-form lazy-validation v-model="valido" ref="form">
                                <v-text-field
                                    label="Nome do Tipo de Veículo"
                                    outline
                                    v-model="tipo_data.denominacao"
                                    :rules="[
                                        (v) => !!v || 'Esse campo é obrigatório'
                                    ]"
                                ></v-text-field>
                            </v-form>
                        </v-stepper-content>
                        <v-stepper-content step="3" class="justify-center ma-0 pa-0 text-xs-center error--text">
                            <h2 v-if="tipoSelecionado">Tem certeza que você desaja excluir o tipo de veículo "<b>{{ tipoSelecionado.denominacao }}</b>"?</h2>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>
            <v-card-actions class="ma-0 pa-0 justify-space-around" v-if="step !== 1">
                <v-btn
                    large
                    color="info"
                    block
                    :disabled="!valido"
                    @click="salvarTipoDeVeiculo"
                    v-if="step === 2"
                    flat
                >
                    <v-icon class="mr-2">save</v-icon>
                    Salvar
                </v-btn>
                <template v-else>
                    <v-flex xs6>
                        <v-btn
                            large
                            block
                            @click="step = 1, tipoSelecionado = undefined"
                            flat
                        >
                            NÃO
                        </v-btn>
                    </v-flex>
                    <v-divider vertical></v-divider>
                    <v-flex xs6>
                        <v-btn
                            large
                            color="error"
                            block
                            @click="apagarTipoDeVeiculo"
                            flat
                        >
                            SIM
                        </v-btn>
                    </v-flex>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: () => ({
        step: 1,
        valido: false,
        tipoSelecionado: undefined,
        ativarDialog: false,
        alerta: {
            tipo: 'error',
            texto: 'Esse tipo de veículo já foi cadastrado',
            ativo: false
        },
        tipo_data: {
            denominacao: undefined
        }
    }),
    computed: {
        tiposVeiculo () {
            return this.$store.getters.tiposVeiculo
        },
        loading () {
            return this.$store.getters.loading
        },
        titulo () {
            if (this.step === 1) return 'TIPOS DE VEÍCULOS'
            else if (this.step === 2 && !this.tipoSelecionado) return 'CADASTRAR TIPOS DE VEÍCULO'
            else if (this.step === 2 && this.tipoSelecionado) return 'EDITAR TIPOS DE VEÍCULO'
            else return 'APAGAR TIPOS DE VEÍCULO'
        }
    },
    beforeMount () {
        if (this.ativarDialog) this.pegarTiposDeVeiculos()
    },
    watch: {
        ativarDialog (val) {
            if (val) {
                this.pegarTiposDeVeiculos()
            } else {
                this.step = 1
                this.$refs.form.reset()
                this.tipoSelecionado = undefined
            }
        },
        tipoSelecionado (val) {
            if (val) {
                this.tipo_data = { ...val }
            } else {
                this.$refs.form.reset()
            }
        }
    },
    methods: {
        ativarAlerta (texto, tipo) {
            this.alerta.texto = texto
            this.alerta.tipo = tipo
            this.alerta.ativo = true
            const interval = setInterval(() => {
                this.alerta.ativo = false
                clearInterval(interval)
            }, 5000)
        },
        pegarTiposDeVeiculos () {
            this.$store.dispatch('carregarTiposVeiculo')
        },
        salvarTipoDeVeiculo () {
            if (this.$refs.form.validate()) {
                this.$store.dispatch(
                    this.tipoSelecionado ? 'atualizarTipoVeiculo' : 'cadastroTipoVeiculo',
                    this.tipo_data
                ).then(() => {
                    this.pegarTiposDeVeiculos()
                    this.step = 1
                    this.ativarAlerta(`Tipo de veículo ${this.tipoSelecionado ? 'editado' : 'cadastrado'} com sucesso`, 'success')
                    this.tipoSelecionado = undefined
                    this.$refs.form.reset()
                })
            }
        },
        apagarTipoDeVeiculo () {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('deletarTipoVeiculo', this.tipoSelecionado).then(() => {
                    this.pegarTiposDeVeiculos()
                    this.step = 1
                    this.ativarAlerta('Tipo de veículo deletado com sucesso', 'success')
                    this.tipoSelecionado = undefined
                })
            }
        }
    }
}
</script>

<style>

</style>
